import { render, staticRenderFns } from "./PinBatchList.vue?vue&type=template&id=31c5a7a2&scoped=true"
import script from "./PinBatchList.vue?vue&type=script&lang=js"
export * from "./PinBatchList.vue?vue&type=script&lang=js"
import style0 from "./PinBatchList.vue?vue&type=style&index=0&id=31c5a7a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5a7a2",
  null
  
)

export default component.exports